<template>
  <div class="popup_check">
    <Div class="icon flex">
      <i class="el-icon-warning-outline"></i>
      
    </Div>
    <div class="text">
        <div class="text_title"><span v-if="remind"></span>{{ title }}</div>

      <Div v-html="text"></Div>
      <slot></slot>
    </div>
    <div  class="btn flex" v-if="remind" >
      <button  type="button" class="btn_primary" @click="go('upload')">去上傳檔案</button>
      <button type="button" class="btn_gray" @click="cancel('pending')">暫時不處理</button>
    </div>
    <div class="btn flex" v-else>
      <button v-if="enterType" class="btn_primary">
        處理中<i class="el-icon-loading"></i>
      </button>
      <button v-else type="button" class="btn_primary" @click="go">確認</button>
      <button type="button" class="btn_gray" @click="cancel">取消</button>
    </div>
  </div>
</template>
<style lang="scss">
.popup_check {
  font-size: 14px;
  letter-spacing: 2px;
  margin: 0 auto;
  width: fit-content;
  .icon {
    margin: 0 auto;
    width: 40px;
    height: 40px;
    border-radius: 50px;
    font-weight: bold;
    font-size: 50px;
    color: #ffc62c;
    justify-content: center;
    align-items: center;
    animation: big 0.3s 0.1s backwards ease-in-out;
  }
  .text {
    margin: 20px 0 0 0;
    .text_title {
      font-size: 20px;
      font-weight: bold;
      color: var(--mainColor);
      margin: 5px 0 20px 0;
      text-align: center;

      span {
        margin: 0 5px;
        color: red;
        font-size: 25px;
      }
    }
  }
  .btn {
    > button {
      margin: 0 3px;
    }
    margin: 20px 0 0 0;
  }
  @keyframes big {
    0% {
      transform: scale(0);
    }
    80% {
      transform: scale(1.1);
    }
    90% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }
}
</style>
<script>
export default {
  name: "popup_check",
  props: {
    text: String,
    enterType: {
      type: Boolean,
      default: false,
    },
    title: String,
    remind: Boolean,
  },
  methods: {
    go(value) {
      this.$emit("go",value);
    },
    cancel(value) {
      this.$emit("cancel",value);
    },
  },
};
</script>